import * as Config from '../../../../config';
import React, { useCallback, useContext } from "react";
import { useDispatch, ReactReduxContext } from 'react-redux';

import {
  addHistoryTracks,
  setOnAir,
  addReplayTracks,
  setTickItemID,
  addToast
} from "../../../../actions/index"

import {
  enableAutomix,
  setStoreAutomix,
  setPlaylistAutomix,
  setUidAutomix,
  loadIndexAutomix
} from "../redux/actions/index";

// Store Automix Management
const useAutomix = (api) => {
  const { store } = useContext(ReactReduxContext)
  const { getState } = store;
  const dispatch = useDispatch();

  dispatch(enableAutomix(true));

  const load = useCallback((pid, isFresh = false) => {
    const state = getState();
    if (state.playlistAutomix.tracks.length > 0) {
      const actualPlaylist = [...state.playlistAutomix.tracks];

      let loadIndex = 0;
      if (state.loadIndexAutomix === null) {
        if (isFresh) {
          // console.log('AUTOMIX - USEAUTOMIX - FRESH PLAYLIST - LOAD THE FIRST');

          // DEPRECATED - FRESH PLAYLIST BUT START ON THE TRACK ALREADY PLAY
          // const currentTrackID = state.onAir.reduce((result, current) => (!result) ? (actualPlaylist.find( x => current === x.id ) ? current : null) : result, null);
          // if (currentTrackID) {
          //   loadIndex = actualPlaylist.findIndex( x => currentTrackID === x.id );
          // }
        } else {
          const checkTrackID = (state.onAir) ? state.onAir[(pid === 1) ? 1 : 0] : null;
          if (checkTrackID) {
            const checkIndex = actualPlaylist.findIndex( x => checkTrackID === x.id );
            loadIndex = (checkIndex < 0) ? 0 : ((checkIndex + 1 < actualPlaylist.length) ? checkIndex + 1 : -1)
          }
          // console.log('AUTOMIX - USEAUTOMIX - NEXT TRACK LOADING', loadIndex);
        }
      } else { // FORCE LOAD INDEX
        loadIndex = state.loadIndexAutomix;
        // console.log('AUTOMIX - USEAUTOMIX - FORCE LOAD AUTOMIX INDEX', loadIndex)
      }

      let track = actualPlaylist.find( (x, i) => i === loadIndex );
      if (track) {
        const hlsEnabled = (state.isSubscribed && (track.is_available_for_streaming && !track.pre_order));
        api.loadAudio(pid, track, true, hlsEnabled, false);
        if (!hlsEnabled && state.isSubscribed) {
          dispatch(addToast({ content: <span>Download only, full-track streaming is unavailable.</span>, typeClass: 'warning', iconStyle: { padding: '32px 16px', marginRight: 16 } }));
        }
        dispatch(setPlaylistAutomix({ tracks: [...actualPlaylist], from: state.playlistAutomix.from, active: loadIndex, next: state.playlistAutomix.next, isFresh }));
        dispatch(addHistoryTracks({ ...track, selected: false }));
        dispatch(addReplayTracks(track.id));
        dispatch(setOnAir(pid, track.id));
        dispatch(loadIndexAutomix(null));
        dispatch(setTickItemID(`DI-${track.id}-TRACK`));
      }

      if (loadIndex === -1 /* || loadIndex + 1 === actualPlaylist.length*/) { // End playlist stop loop
        setTimeout(() => { window['YouDJ'] && window['YouDJ'].automix_off(); }, 100)
      }

      if (actualPlaylist.length === 1) {
        api.getFromURI(state.playlistAutomix.next).then( res => {
          const tracks = [ ...actualPlaylist, ...res.data.results.map(Config.formattedFromBP) ] ;
          const next = res.data.next;
          dispatch(setPlaylistAutomix({ tracks, next }));
        } )
      }
    }
  }, [api, dispatch, getState])

  const disable = () => { dispatch(setUidAutomix(null)) }

  const storeX = { load, disable };
  setTimeout(() => { dispatch(setStoreAutomix(storeX)) }, 100);
  return null;
};

export default useAutomix;
